export default "__VITE_ASSET__cca346ac__"